// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "LegalDocumentationPage-module--arrow-up-and-down--d0dd2";
export var container = "LegalDocumentationPage-module--container--341a4";
export var description = "LegalDocumentationPage-module--description--c312b";
export var section = "LegalDocumentationPage-module--section--6ccb4";